
import { showSnackbar } from 'utils/snack_bar/store/action';
import { CREATE_CATEGORY, DELETE_CATEGORY, UPDATE_CATEGORY } from '../graphql/mutation';
import { FETCH_CATEGORIES_BY_GROUP_ID } from '../graphql/query';
import { actionTypes, UpdateVideoCategoryInput, VideoCategoryInput, VideoCategoryProps } from './actionType';
import { executeMutation, executeQuery } from 'utils/services/apiServices';

export const fetchVideoCategoriesRequest = () => ({
    type: actionTypes.FETCH_VIDEO_CATEGORIES_REQUEST
});

export const fetchVideoCategoriesSuccess = (payload: VideoCategoryProps[]) => ({
    type: actionTypes.FETCH_VIDEO_CATEGORIES_SUCCESS,
    payload
});

export const fetchVideoCategoriesFail = (payload: string) => ({
    type: actionTypes.FETCH_VIDEO_CATEGORIES_FAIL,
    payload
});

export const fetchVideoCategories = (group_id:string) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchVideoCategoriesRequest());
            const input = {
                group_id: group_id
            };
            const response = await executeQuery(FETCH_CATEGORIES_BY_GROUP_ID,input);
            const jsonData = response.data?.fetchCategoriesByGroupId;
            if (jsonData?.error === null) {
                dispatch(fetchVideoCategoriesSuccess(jsonData?.data.categories));
            } else {
                dispatch(fetchVideoCategoriesFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchVideoCategoriesFail('Failed to fetch VideoCategories'));
        }
    };
};

export const createVideoCategorySuccess= (payload: VideoCategoryProps) => ({
    type: actionTypes.CREATE_VIDEO_CATEGORY_SUCCESS,
    payload
});
export const createVideoCategoryFail= (payload: string) => ({
    type: actionTypes.CREATE_VIDEO_CATEGORY_FAIL,
    payload
});
export const createVideoCategory = (input: VideoCategoryInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            const response = await executeMutation(CREATE_CATEGORY, inputData);
            const jsonData = response.data?.createCategory;
            if (jsonData?.error === null) {
                dispatch(createVideoCategorySuccess(jsonData?.data.categories));
                 dispatch(showSnackbar('Success! category created.'));
            } else {
                dispatch(createVideoCategoryFail(jsonData?.error.message))
                 dispatch(showSnackbar('Fail to create.'));
            }
        } catch (error: any) {
            dispatch(createVideoCategoryFail('Something went wrong, Try again later'))
        }
    };
};


export const updateVideoCategorySuccess= (payload: VideoCategoryProps) => ({
    type: actionTypes.UPDATE_VIDEO_CATEGORY_SUCCESS,
    payload
});
export const updateVideoCategoryFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_CATEGORY_FAIL,
    payload
});
export const updateVideoCategory = (input: UpdateVideoCategoryInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            const response = await executeMutation(UPDATE_CATEGORY, inputData);
            const jsonData = response.data?.updateCategory;
            if (jsonData?.error === null) {
                dispatch(updateVideoCategorySuccess(jsonData?.data.category));
                 dispatch(showSnackbar('Success! category updated.'));
            } else {
                dispatch(updateVideoCategoryFail(jsonData?.error.message))
                 dispatch(showSnackbar('Fail to updated.'));
            }
        } catch (error: any) {
            dispatch(updateVideoCategoryFail('Something went wrong, Try again later'))
        }
    };
};


export const deleteVideoCategorySuccess= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_CATEGORY_SUCCESS,
    payload
});

export const deleteVideoCategoryFailure= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_CATEGORY_FAIL,
    payload
});
export const deleteVideoCategory = (category_id: string, folder_id: string) => {
    return async (dispatch: any) => {
        try {
            const input = {
                category_id:category_id,
                folder_id:folder_id,
            }
            const response = await executeMutation(DELETE_CATEGORY, input);
            const jsonData = response.data?.deleteCategory;
            if (jsonData?.error === null) {
                dispatch(deleteVideoCategorySuccess(category_id));
                 dispatch(showSnackbar('Success! category deleted.'));
            } else {
                dispatch(deleteVideoCategoryFailure(jsonData?.error.message));
                 dispatch(showSnackbar('Fail to delete.'));
            }
        } catch (error: any) {
            dispatch(deleteVideoCategoryFailure('Something went wrong, Try again later'));
        }
    };
};



